import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import SalesStaticsContainer from '../../containers/sales-statics/SalesStaticsContainer';

const SalesStaticsViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="결산관리/영업 통계" icon="statistics" />
      <SalesStaticsContainer />
    </div>
  );
};

export default SalesStaticsViewPage;
